import React, { useState } from "react";
import ReactDOM from "react-dom";
import {
    Modal,
    Button,
    FormText,
    FormGroup,
    FormLabel,
    FormControl
} from "react-bootstrap";
import { Link } from "react-router-dom";
import Language from "../../helpers/language";
import Util from "../../helpers/util";
import parse from "html-react-parser";

export const ContentTypeText = props => {
    const { content } = props;

    let text = "text" in content ? content.text : "";
    text = Util.hyperlink( text )

    return (
        <div className='daily-questions__question'>
            <h4>
                {parse(text)}
            </h4>
        </div>
    );
};
